import React from 'react';
import PropTypes from 'prop-types';

import Dialog from './Dialog';

const HelpDialog = ({ title, children }) => (
  <Dialog id="helpDialog" title={title} footer={false}>
    <div className="mb-3">{children}</div>
  </Dialog>
);

HelpDialog.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};

export default HelpDialog;
